module.exports = __webpack_public_path__ + "static/img/mens_overig_1.5c58c07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blocks/mens_overig_1.svg
// module id = iSTn
// module chunks = 0